export default "__VITE_ASSET__CwliT8Rg__"